const DB_NAME = "trekkin-waypoint-offline-images";
const DB_VERSION = 1;
const STORE_NAME = "images";
const REF_PREFIX = "waypoint-idb://";

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("indexeddb_unavailable"));
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE_NAME)) {
        request.result.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("indexeddb_open_failed"));
  });
}

function makeId() {
  return `wpimg-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function isWaypointOfflineImageRef(value) {
  return String(value || "").startsWith(REF_PREFIX);
}

function refToId(value) {
  return isWaypointOfflineImageRef(value)
    ? String(value).slice(REF_PREFIX.length)
    : "";
}

export async function storeWaypointOfflineImage(file) {
  if (!(file instanceof Blob)) throw new Error("waypoint_image_invalid");
  const database = await openDb();
  const id = makeId();
  await new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).put({
      id,
      blob: file,
      name: String(file?.name || `waypoint_${Date.now()}.jpg`),
      type: String(file?.type || "image/jpeg"),
      createdAt: Date.now(),
    });
    transaction.oncomplete = resolve;
    transaction.onerror = () => reject(transaction.error || new Error("waypoint_image_store_failed"));
  });
  database.close();
  return `${REF_PREFIX}${id}`;
}

export async function loadWaypointOfflineImageFile(value) {
  const id = refToId(value);
  if (!id) return null;
  const database = await openDb();
  const row = await new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, "readonly");
    const request = transaction.objectStore(STORE_NAME).get(id);
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error || new Error("waypoint_image_read_failed"));
  });
  database.close();
  if (!(row?.blob instanceof Blob)) return null;
  return new File([row.blob], row.name || `${id}.jpg`, {
    type: row.type || row.blob.type || "image/jpeg",
  });
}

export async function removeWaypointOfflineImage(value) {
  const id = refToId(value);
  if (!id) return false;
  const database = await openDb();
  await new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).delete(id);
    transaction.oncomplete = resolve;
    transaction.onerror = () => reject(transaction.error || new Error("waypoint_image_delete_failed"));
  });
  database.close();
  return true;
}

export async function removeWaypointOfflineImagesFromPayload(payload = {}) {
  const values = [
    payload?.imageUrl,
    payload?.coverImage,
    ...(Array.isArray(payload?.galleryImages) ? payload.galleryImages : []),
  ];
  const refs = [...new Set(values.filter(isWaypointOfflineImageRef))];
  await Promise.all(refs.map((value) => removeWaypointOfflineImage(value).catch(() => false)));
}

